export default () => ({
  copies: 2,
  groupWidth: 0,
  resizeObserver: null,

  init() {
    this.$nextTick(() => {
      this.calculateCopies();

      this.resizeObserver = new ResizeObserver(() => {
        this.calculateCopies();
      });

      this.resizeObserver.observe(this.$el);
    });
  },

  calculateCopies() {
    const group = this.$refs.group;

    if (!group) return;

    this.groupWidth = group.offsetWidth;

    if (!this.groupWidth) return;

    const viewportWidth = this.$el.offsetWidth;

    this.copies = Math.max(2, Math.ceil((viewportWidth * 2) / this.groupWidth) + 1);

    this.$el.style.setProperty('--new-marquee-distance', `${this.groupWidth}px`);
  },

  destroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
});
